exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "success-order-carpenter {\n  display: block;\n  padding-top: 20px;\n  margin-bottom: 20px;\n  border-top: 1px solid #ddd;\n}\nsuccess-order-carpenter .success-content {\n  margin-top: 100px;\n  margin-bottom: 150px;\n}\nsuccess-order-carpenter .success-content > md-icon {\n  color: #039174;\n  user-select: none;\n  font-size: 50px;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  min-height: 50px;\n  min-width: 50px;\n}\nsuccess-order-carpenter .success-content > p {\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n}", ""]);

// exports
